export default "__VITE_ASSET__f6dfd11c__"